export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-download-564cf11ea2279425b6f31ba0c7bedbc8.svg";